{
  " Reset Password": " Reset Password",
  "<0>Or click <1>{t('here ')}</1> to sign in</0>": "<0>Or click <1>{t('here ')}</1> to sign in</0>",
  "Accept Invitation": "Accept Invitation",
  "Accept Invite": "Accept Invite",
  "Accepting your invitation will give you access to the Weave's admin portal app.": "Accepting your invitation will give you access to the Weave's admin portal app.",
  "Active": "Active",
  "Add Email": "Add Email",
  "Add Integration": "Add Integration",
  "Add Invitation": "Add Invitation",
  "Add Locations": "Add Locations",
  "Add More Methods": "Add More Methods",
  "Add Phone Number": "Add Phone Number",
  "Add Users": "Add Users",
  "Add Your Email Address": "Add Your Email Address",
  "Add Your Phone Number": "Add Your Phone Number",
  "Add an additional layer of security to your account during login.": "Add an additional layer of security to your account during login.",
  "Add these users to locations below.": "Add these users to locations below.",
  "Admin Access": "Admin Access",
  "After you click Submit, user will receive a text message to verify mobile number for password reset purposes.": "After you click Submit, user will receive a text message to verify mobile number for password reset purposes.",
  "After you click save, you will receive a text to verify your mobile number for password reset purposes": "After you click save, you will receive a text to verify your mobile number for password reset purposes",
  "An error occurred while deleting.": "An error occurred while deleting.",
  "Apply to All": "Apply to All",
  "Apply to All Invited Users": "Apply to All Invited Users",
  "Are you sure you want to delete the selected user?": "Are you sure you want to delete the selected user?",
  "Are you sure you want to delete the selected users?": "Are you sure you want to delete the selected users?",
  "Are you sure you want to remove this user's access to {{locationName}}?": "Are you sure you want to remove this user's access to {{locationName}}?",
  "Assign Locations": "Assign Locations",
  "At least one permission is must be selected": "At least one permission is must be selected",
  "Back": "Back",
  "Basic Access": "Basic Access",
  "Begin": "Begin",
  "Bulk Delete Users": "Bulk Delete Users",
  "Cancel": "Cancel",
  "Change the password required when logging into your account.": "Change the password required when logging into your account.",
  "Choose Location": "Choose Location",
  "Choose Locations": "Choose Locations",
  "Clear": "Clear",
  "Click": "Click",
  "Click the button below to begin setting up your account": "Click the button below to begin setting up your account",
  "Confirm": "Confirm",
  "Continue": "Continue",
  "Create a Password": "Create a Password",
  "Customize this user's permissions using our previous (older) permissions system.": "Customize this user's permissions using our previous (older) permissions system.",
  "Customize this user's permissions.": "Customize this user's permissions.",
  "Data Sync": "Data Sync",
  "Delete": "Delete",
  "Delete Method": "Delete Method",
  "Delete User": "Delete User",
  "Delete Users": "Delete Users",
  "Deleting Location ...": "Deleting Location ...",
  "Don't show this again": "Don't show this again",
  "Done": "Done",
  "Duplicate email address": "Duplicate email address",
  "Easily integrate with your practice management software.": "Easily integrate with your practice management software.",
  "Edit": "Edit",
  "Edit Permissions": "Edit Permissions",
  "Edit Permissions & Location Access": "Edit Permissions & Location Access",
  "Email": "Email",
  "Email Address": "Email Address",
  "Email Password Reset Link": "Email Password Reset Link",
  "Email address is required": "Email address is required",
  "Enable Multi-Factor Authentication": "Enable Multi-Factor Authentication",
  "Enable using {{contact}}": "Enable using {{contact}}",
  "Enter Your Email Address": "Enter Your Email Address",
  "Enter Your Phone Number": "Enter Your Phone Number",
  "Enter a Phone Number": "Enter a Phone Number",
  "Enter an Email Address": "Enter an Email Address",
  "Enter the code sent to {{address}} to complete setup.": "Enter the code sent to {{address}} to complete setup.",
  "Enter your email address to receive an authentication code.": "Enter your email address to receive an authentication code.",
  "Enter your phone number to receive an authentication code.": "Enter your phone number to receive an authentication code.",
  "Error getting users: {{error}}": "Error getting users: {{error}}",
  "Error resetting password no profile present": "Error resetting password no profile present",
  "Error resetting your password: ": "Error resetting your password: ",
  "Error sending verification email: ": "Error sending verification email: ",
  "Error updating user profile": "Error updating user profile",
  "Error updating your profile ": "Error updating your profile ",
  "Every time you enter your password, Weave will ask you for a verification code to confirm your identity.": "Every time you enter your password, Weave will ask you for a verification code to confirm your identity.",
  "Failed to check password security": "Failed to check password security",
  "Failed to delete method.": "Failed to delete method.",
  "Failed to delete {{failureCount}} user(s)": "Failed to delete {{failureCount}} user(s)",
  "Failed to enable multi-factor authentication": "Failed to enable multi-factor authentication",
  "Failed to mark method as primary.": "Failed to mark method as primary.",
  "Failed to resend invite. Please try again.": "Failed to resend invite. Please try again.",
  "Failed to send validation code.": "Failed to send validation code.",
  "Finish Account Setup": "Finish Account Setup",
  "First Name": "First Name",
  "Full access to all features and settings": "Full access to all features and settings",
  "Get A New Link": "Get A New Link",
  "Get started quickly with one of these curated options.": "Get started quickly with one of these curated options.",
  "Grant users access to essential Weave features and products for day-to-day use.": "Grant users access to essential Weave features and products for day-to-day use.",
  "Grant users full control, including the ability to read, write, and manage transactions across Weave tools.": "Grant users full control, including the ability to read, write, and manage transactions across Weave tools.",
  "Help protect your patients' sensitive information by enabling an extra security step. You'll get a code by email or text to ensure only authorized access.": "Help protect your patients' sensitive information by enabling an extra security step. You'll get a code by email or text to ensure only authorized access.",
  "Individual Permissions": "Individual Permissions",
  "Invalid email address": "Invalid email address",
  "Invitation resent successfully.": "Invitation resent successfully.",
  "Invitations": "Invitations",
  "Invite New Users": "Invite New Users",
  "Invite users to your organization by entering their email addresses below.": "Invite users to your organization by entering their email addresses below.",
  "Last Name": "Last Name",
  "Legacy Permissions": "Legacy Permissions",
  "Loading user details": "Loading user details",
  "Location": "Location",
  "Location Unavailable": "Location Unavailable",
  "Locations": "Locations",
  "Manage Multi-factor Authentication": "Manage Multi-factor Authentication",
  "Manage Permissions": "Manage Permissions",
  "Manage Source": "Manage Source",
  "Manage how you receive verification codes for extra account security.": "Manage how you receive verification codes for extra account security.",
  "Manage this user's access to features across different locations in the Weave app.": "Manage this user's access to features across different locations in the Weave app.",
  "Manage this user's access to features in the Weave app.": "Manage this user's access to features in the Weave app.",
  "Mark as Primary": "Mark as Primary",
  "Mobile Number": "Mobile Number",
  "Mobile Number Not Verified": "Mobile Number Not Verified",
  "Mobile Number Verified": "Mobile Number Verified",
  "Mobile Verification sent": "Mobile Verification sent",
  "Mobile number verification": "Mobile number verification",
  "Multi-Factor Authentication": "Multi-Factor Authentication",
  "Multi-Factor Authentication with Email Address is Enabled": "Multi-Factor Authentication with Email Address is Enabled",
  "Multi-Factor Authentication with Phone Number is Enabled": "Multi-Factor Authentication with Phone Number is Enabled",
  "Multi-factor Authentication": "Multi-factor Authentication",
  "Name": "Name",
  "Next": "Next",
  "No Users": "No Users",
  "Not Validated": "Not Validated",
  "Note: You don't have permission to delete the following users. If you proceed, these users will not be deleted:": "Note: You don't have permission to delete the following users. If you proceed, these users will not be deleted:",
  "Off": "Off",
  "On": "On",
  "Password": "Password",
  "Password Reset Email Sent": "Password Reset Email Sent",
  "Password Reset Failed": "Password Reset Failed",
  "Perfect! You've successfully joined!": "Perfect! You've successfully joined!",
  "Permissions and Location Access": "Permissions and Location Access",
  "Personal Info": "Personal Info",
  "Phones Admin": "Phones Admin",
  "Please ensure the location of the source you are trying to modify is selected in your location picker": "Please ensure the location of the source you are trying to modify is selected in your location picker",
  "Please ensure the location you are trying to add a source to is selected in your location picker": "Please ensure the location you are trying to add a source to is selected in your location picker",
  "Please ensure the location you are trying to modify is selected in your location picker": "Please ensure the location you are trying to modify is selected in your location picker",
  "Please enter a valid address": "Please enter a valid address",
  "Please finish setting up your account": "Please finish setting up your account",
  "Please fix the errors in the invite form": "Please fix the errors in the invite form",
  "Please, talk to your administrator, generate a new token and try again.": "Please, talk to your administrator, generate a new token and try again.",
  "Quick Select Options": "Quick Select Options",
  "Remove Location Access": "Remove Location Access",
  "Require multi-factor authentication at login": "Require multi-factor authentication at login",
  "Resend": "Resend",
  "Resend Invite": "Resend Invite",
  "Resend Verification": "Resend Verification",
  "Reset Password": "Reset Password",
  "Save": "Save",
  "Save Changes": "Save Changes",
  "Search name or email address": "Search name or email address",
  "Security": "Security",
  "Select a role for the parent location": "Select a role for the parent location",
  "Select at least one permission": "Select at least one permission",
  "Send Code Via Email": "Send Code Via Email",
  "Send Code Via Text": "Send Code Via Text",
  "Send Email": "Send Email",
  "Send Invites": "Send Invites",
  "Sign In ": "Sign In ",
  "Skip and enable later": "Skip and enable later",
  "Some users could not be invited: Please see results below": "Some users could not be invited: Please see results below",
  "Something went wrong": "Something went wrong",
  "Status": "Status",
  "Successfully added to location, please sign in to view location.": "Successfully added to location, please sign in to view location.",
  "Successfully added to location.": "Successfully added to location.",
  "Successfully created account.": "Successfully created account.",
  "Successfully deleted.": "Successfully deleted.",
  "Successfully disabled multi-factor authentication": "Successfully disabled multi-factor authentication",
  "Successfully enabled multi-factor authentication": "Successfully enabled multi-factor authentication",
  "Successfully updated user": "Successfully updated user",
  "Successfully updated your profile": "Successfully updated your profile",
  "Super Admin": "Super Admin",
  "That verification method is already in use. Try a different one.": "That verification method is already in use. Try a different one.",
  "The reset password has been sent to": "The reset password has been sent to",
  "The selected permissions will be applied to all users": "The selected permissions will be applied to all users",
  "The verification code you entered is incorrect. Please check the code and try again. If you continue to experience issues, you can request a new verification code.": "The verification code you entered is incorrect. Please check the code and try again. If you continue to experience issues, you can request a new verification code.",
  "There was an error when trying to validate your user. Validation tokens are only good for 7 days. ": "There was an error when trying to validate your user. Validation tokens are only good for 7 days. ",
  "This link has already been used, or expired": "This link has already been used, or expired",
  "This page will redirect to the login page in a few seconds.": "This page will redirect to the login page in a few seconds.",
  "This setting is recommended and significantly reduces the risk of unauthorized access to your account and patient data.": "This setting is recommended and significantly reduces the risk of unauthorized access to your account and patient data.",
  "Type or Copy/Paste Email Addresses": "Type or Copy/Paste Email Addresses",
  "Unexpected error adding method. Please contact support if the problem persists.": "Unexpected error adding method. Please contact support if the problem persists.",
  "Updating User ....": "Updating User ....",
  "Updating Your Profile ..": "Updating Your Profile ..",
  "User invited successfully": "User invited successfully",
  "User needs to be added to at least one location": "User needs to be added to at least one location",
  "User with this email already exists": "User with this email already exists",
  "User {{current}} of {{count}}_one": "User {{current}} of {{count}}",
  "User {{current}} of {{count}}_other": "User {{current}} of {{count}}",
  "Users": "Users",
  "Users invited successfully": "Users invited successfully",
  "Validate Method": "Validate Method",
  "Verification Code": "Verification Code",
  "Verify": "Verify",
  "Verify Email Address": "Verify Email Address",
  "Verify Phone Number": "Verify Phone Number",
  "View Multi-Factor Methods": "View Multi-Factor Methods",
  "View and manage user accounts, including their roles and permissions.": "View and manage user accounts, including their roles and permissions.",
  "We Emailed You a Code": "We Emailed You a Code",
  "We Texted You a Code": "We Texted You a Code",
  "We use this app to configure office settings and perform various admin tasks (like Data Import Tool).": "We use this app to configure office settings and perform various admin tasks (like Data Import Tool).",
  "Weave's Admin Portal!": "Weave's Admin Portal!",
  "You do not have permission to delete this location.": "You do not have permission to delete this location.",
  "You do not have permission to edit this location.": "You do not have permission to edit this location.",
  "You don't have any users yet. Add a user to get started.": "You don't have any users yet. Add a user to get started.",
  "You've been invited to join": "You've been invited to join",
  "accepting invitation": "accepting invitation",
  "email": "email",
  "enter email": "enter email",
  "here ": "here ",
  "loading profile": "loading profile",
  "sending email": "sending email",
  "to immediately go to the login page.": "to immediately go to the login page.",
  "{status}": "{status}",
  "{{successCount}} user(s) deleted successfully": "{{successCount}} user(s) deleted successfully"
}
